import type { AnyAction, Reducer } from '@reduxjs/toolkit';

import { DEFAULT_META_KEY } from './constants';

/**
 * Create High ordered reducer.
 * Contain map of simple reducers. Pass action to target reducer
 *
 * @param reducer
 * @param key
 */
export const createMultiReducer =
    <S extends Parameters<R>[0], R extends Reducer>(
        reducer: R,
        key: string = DEFAULT_META_KEY,
    ): ((state: Record<string, S> | undefined, action: AnyAction) => Record<string, ReturnType<R> | undefined>) =>
    (state = {}, action) => {
        const instanceKey = action.meta?.[key];

        if (instanceKey) {
            return {
                ...state,
                [instanceKey]: reducer(state[instanceKey], action),
            };
        }

        return state;
    };
